module.exports = __webpack_public_path__ + "static/img/科协优秀奖78.38addd43.jpg";